import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import { useStoreState } from 'easy-peasy';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';

import Layout from '../../common/components/layout';
import ProfileIntroduction from './components/profile-introduction/profile-introduction';
import ProfilePerson from './components/profile-personal/profile-personal';
import ProfileChangePassword from './components/profile-change-password/profile-change-password';

import './profile.scss';

const ProfilePage = () => {
  const { formatMessage } = useIntl();
  const [currentTab, setCurrentTab] = useState('myProfile');
  const [imageUpdate, setImageUpdate] = useState(false);
  const userInfo = useStoreState(state => state.global?.userInfo);

  // tracking data appInsights
  const appInsights = useAppInsightsContext();
  const metricData = {
    average: 10,
    name: 'React Component Engaged Time (seconds)',
    sampleCount: 1
  };
  const additionalProperties = { 'Component Name': 'ProfilePage' };
  appInsights.trackMetric(metricData, additionalProperties);
  // end tracking data appInsights

  return (
    <Layout hiddenFooter>
      <div className="profile-page">
        <Helmet>
          <title>{formatMessage({ id: 'seo.profile.title_tag' })}</title>
          <meta name="description" content={formatMessage({ id: 'seo.profile.meta_description' })} />
        </Helmet>
        {/* {viewportWidth > 991 ? <PricingStarted /> : <MobilePricingStarted />} */}

        <div className="profile-container">
          <ProfileIntroduction
            dataUserInfo={userInfo}
            setImageUpdate={setImageUpdate}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />

          {currentTab === 'myProfile' && <ProfilePerson dataUserInfo={userInfo} imageUpdate={imageUpdate} />}

          {/* {currentTab === "changePassword" && (
            <ProfileChangePassword dataUserInfo={userInfo} />
          )} */}
        </div>
      </div>
    </Layout>
  );
};

export default ProfilePage;
